module.exports = __webpack_public_path__ + "static/media/cockroach(18).506f89f0.PNG";